export default function TokenomicsInfo({ totalSupply }) {
    // Format the total supply with commas for better readability
    const formatNumber = (num) => {
      return num ? Number(num).toLocaleString('en-US', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 0
      }) : "0";
    };
  
    return (
      <div className="info-panel">
        <h2 className="text-xl font-bold mb-2">📊 Tokenomics</h2>
        <p>
          <strong>Total Supply:</strong> {formatNumber(totalSupply)} / 21,000,000 MINE
        </p>
        <p>
          <strong>Max Supply:</strong> 21,000,000 MINE
        </p>
        <p>
          <strong>Minimum ETH Balance to Mint:</strong> 0.001 ETH
        </p>
        <p>
          <strong>Mint Cooldown:</strong> 1 minute per wallet
        </p>
        <p>
          <strong>Initial Multiplier:</strong> 65,536 tokens per ETH
        </p>
        <p>
          <strong>Halving Interval:</strong> Every 210,000 tokens minted
        </p>
        <p className="mt-2 text-sm text-gray-300">
          💡 Each wallet can mint tokens based on their ETH balance. The amount minted halves after every 210k tokens, and you must wait 1 minute between mints. Max supply is 21 million tokens.
        </p>
      </div>
    );
  }